import SpineSymbol from 'core/display/spines/SpineSymbol'
import Sprite from 'core/display/Sprite'
import { signal } from 'services/SignalsService'
import { social } from 'settings/custom/build'
import { reelsSettings } from 'settings/custom/reels'
import { update } from 'settings/custom/social'
import { time } from 'settings/custom/win'
import { Device } from 'utils/Device'
import { create, replace } from 'utils/Object'
import { tint } from 'utils/Tweens'

export default class Symbol extends PIXI.Container {
  constructor(id, settings) {
    super()
    this.id = id
    this.settings = settings
    this._sprite = null
    this._scale = Device.isDesktop() ? 1 : 0.5
    this.isSticky = false
    this.createSymbol(id)
  }

  reset(){
    this._spine.stop()
  }

  get sprite() {
    return this._sprite
  }

  createSymbol(id) {
    this.createSprite(id)
    this.createSpine(id)
  }

  createSpine(id){
    const { win, items } = this.settings
    const assetId = this.getAssetIdBySymbolId(id)

    this._spine = new SpineSymbol(create(items, replace(win, 'spine', assetId)))
    this._spine.scale.set(this._scale)
    this._spine.visible  = true
    this._spine.stop()
    this.addChild(this._spine)
    if(reelsSettings.hasOwnProperty('overSymbols')){
      const overSymbols = reelsSettings.overSymbols
      overSymbols.symbol.forEach((symbol, index) => {
        if(symbol === id){
          this._spine.x = overSymbols.parameter.spine[index].x
          this._spine.y = overSymbols.parameter.spine[index].y
        }
      },
      )
    }
  }

  getAssetIdBySymbolId(symbolId) {
    const { symbols } = update
    if (social && symbols && typeof symbols === 'object') {
      return symbols[symbolId] ? symbols[symbolId] : symbolId
    }

    return symbolId
  }

  createSprite(id) {
    const assetId = this.getAssetIdBySymbolId(id)

    this._sprite = new Sprite({ texture: game.getTextureFromAtlases(assetId) })
    this._staticTex = game.getTextureFromAtlases(assetId)
    this._blurTexture = game.getTextureFromAtlases(assetId + '_blur')
    this._sprite.scale.set(this._scale)
    this.addChild(this._sprite)

    if(reelsSettings.hasOwnProperty('overSymbols')){
      const overSymbols = reelsSettings.overSymbols
      overSymbols.symbol.forEach((symbol, index) => {
        if(symbol === id){
          this._sprite.x = overSymbols.parameter.sprite[index].x
          this._sprite.y = overSymbols.parameter.sprite[index].y
        }
      },
      )
    }
  }

  swapSpine(visible){
    this._spine.visible  = visible
    this._spine.setToSetupPose()
    this._sprite.visible = !visible

  }

  playStatic(){
    this.swapSpine(false)
    this._sprite.filters = null
    this._sprite.tint = 0xFFFFFF
    this._sprite.texture = this._staticTex

  }
  playMove(){
    this.swapSpine(false)
    if(this._blurTexture) {
      this._sprite.texture = this._blurTexture
    }
    this._sprite.tint = 0xFFFFFF
  }

  swapSticky(sticky){
    const id = reelsSettings.stickyWild.toString()
    if(sticky){
      this._staticTex =  game.getTextureFromAtlases('sticky')
      this._blurTexture = game.getTextureFromAtlases('sticky_blur')
    }
    else {
      this._staticTex = game.getTextureFromAtlases(id)
      this._blurTexture = game.getTextureFromAtlases(id + '_blur')
    }

  }

  playSpineStop(){
    if(this._spine.state.hasAnimation('stop')) {
      this.swapSpine(true)
      signal.dispatch('SOUND:CASCADE:Scatter:Wild')
      this._spine.playCallBack( 'stop', false, () => {
        this.playStatic()
      })
    }
  }
  playDim(){
    this.swapSpine(false)
    tint(this._sprite, time).then()

  }
  playIdleAnimation(){
    this.swapSpine(true)
    if(this._spine.state.hasAnimation('idle')){
      this._spine.playCallBack('idle', false, () => {
        this.playStatic()
      })
    }
    else{
      this._spine.playCallBack('animation', false, () => {
        this.playStatic()
      })
    }

  }

  playSpineFreeSpin(){
    this.swapSpine(true)
    if(this._spine.state.hasAnimation('bonus')){
      this._spine.playCallBack('bonus', false, () => {
        this.swapSpine(false)
        signal.dispatch('WIN-SCATTER-ANIM:DONE')
      })
    }
  }

  playSticky(current, cb){
    this.swapSpine(true)
    this._staticTex = game.getTextureFromAtlases('sticky')
    this._sprite.texture = this._staticTex
    if(this._spine.state.hasAnimation('sticky-start')) {
      this._spine.playCallBack('sticky-start', false, () => {
        this._spine.stop()
        this.swapSpine(false)
        if(cb){
          cb()
        }
      })

    }

  }

  playCascadeWin(){
    if(this._spine.state.hasAnimation('selection')) {
      this.swapSpine(true)
      this._spine.play('selection', true)
    }
  }

  playCascadeVanish(){
    if(this._spine.state.hasAnimation('vanish')) {
      this.swapSpine(true)
      this._spine.play('vanish', false)
    }

  }

  playCascadeDrop(){
    if(this._spine.state.hasAnimation('total')) {
      this.swapSpine(true)
      this._spine.playCallBack('total', false, () => {
        this._spine.stop()
      })
    }

  }

  makeWinAnimation(totalWin){
    this.swapSpine(true)
    const prefix = this.isSticky ? 'sticky-' : ''
    if(this._spine.state.hasAnimation(`${prefix}total`) && totalWin){
      this._spine.playCallBack(  `${prefix}total`, false, () => {

        this._spine.stop()
        this.swapSpine(false)
      })
    }
    else if(this._spine.state.hasAnimation(`${prefix}win`)){
      this._spine.playCallBack(  `${prefix}win`, false, () => {
        this._spine.stop()
        this.swapSpine(false)
      })
    }
    else{
      this._spine.playCallBack( `${prefix}animation`, false, () => {
        this._spine.stop()
        this.swapSpine(false)
      })
    }

  }

}
